// extracted by mini-css-extract-plugin
export default {"li":"IngredientCard_li__qbUVa","prices":"IngredientCard_prices__QEuEj"};